import { PropsWithChildren, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

interface PortalProps extends PropsWithChildren {
  /** When set, portals here instead of `document.body` (e.g. inside a modal dialog tree for Headless UI inert + stacking). */
  container?: Element | null
}

export function Portal({ children, container }: PortalProps) {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) return null

  const target = container ?? document.body
  return createPortal(children, target)
}
